import React from 'react';
import './Profile.css';

function Profile() {
  // 模拟用户数据
  const userData = {
    name: '张三',
    email: 'zhangsan@example.com',
    phone: '138****1234',
    role: '普通用户',
    registerDate: '2023-01-15',
    lastLogin: '2024-03-20 15:30:45'
  };

  return (
    <div className="profile-page">
      <h2>个人信息</h2>
      
      <div className="profile-card">
        <div className="profile-header">
          <div className="avatar">
            {userData.name.charAt(0)}
          </div>
          <div className="user-info">
            <h3>{userData.name}</h3>
            <p className="user-role">{userData.role}</p>
          </div>
        </div>
        
        <div className="profile-details">
          <div className="detail-item">
            <div className="detail-label">邮箱</div>
            <div className="detail-value">{userData.email}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">手机号</div>
            <div className="detail-value">{userData.phone}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">注册日期</div>
            <div className="detail-value">{userData.registerDate}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">最后登录</div>
            <div className="detail-value">{userData.lastLogin}</div>
          </div>
        </div>
        
        <div className="profile-actions">
          <button className="edit-profile-btn">编辑资料</button>
          <button className="change-password-btn">修改密码</button>
        </div>
      </div>
    </div>
  );
}

export default Profile; 